<template>
	<div>
		<div class="flex">
			<div class="lg:w-1/2 flex"></div>
			<div class="lg:w-1/2 flex justify-end">
				<ButtonBlack class="flex justify-end">
					<router-link
						:to="'/admin/' + section"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
		</div>
		<ListTable
			:itemsTitles="itemsTitles"
			:items="roles"
			:section="section"
			:itemsTable="itemsTable"
		/>
	</div>
</template>

<script>
import ListTable from '@/components/ListTable'
import gql from 'graphql-tag'

export default {
	apollo: {
		roles: {
			query: gql`
				{
					roles(order_by: { rol: asc }) {
						id
						rol
              			allow_hiring
						is_administrator
						country {
							code
						}
						active
					}
				}
			`,
			update(data) {
				return data.roles.map(item => ({
					id: item.id,
					rol: item.rol,
					admin: item.is_administrator ? this.$t('Si') : this.$t('No'),
					hires: item.allow_hiring ? this.$t('Si') : this.$t('No'),
					countryCode: item.country ? item.country.code : '',
					edit: true,
					active: item.active
				}))
			}
		}
	},
	data() {
		return {
			section: 'roles',
			itemsTable: 'roles',
			itemsTitles: ['Id', 'Rol', 'Contratación', 'Administrador', 'Pais']
		}
	},
	components: { ListTable }
}
</script>
